<template>
  <v-tooltip bottom :disabled="!tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        :color="color"
        text-color="white"
        small
        :ripple="false"
        class="status-chip ma-0"
        :class="{ 'cursor-pointer': enableEdit || clickable }"
        @click="emitClick"
      >
        <v-icon left size="14" color="white" class="pl-1 mr-1">
          {{ icon }}
        </v-icon>
        <span>
          {{ shortname }}
        </span>

        <v-icon
          v-if="enableEdit"
          left
          size="14"
          color="white"
          class="edit-icon ml-1 pr-0 mr-0"
        >
          mdi-pencil
        </v-icon>
      </v-chip>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "SenderStatusChip",
  props: {
    status: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    tooltip: {
      type: String,
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statusOption() {
      return this.options.find((option) => option.value === this.status) || {};
    },
    color() {
      return this.statusOption.color || "grey";
    },
    shortname() {
      return this.statusOption.shortname || "--";
    },
    icon() {
      return this.statusOption.icon || "mdi-help-circle";
    },
  },
  methods: {
    emitClick() {
      if (this.enableEdit || this.clickable) this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
.edit-icon {
  display: none;
}
.status-chip:hover .edit-icon {
  display: inline-block;
}
</style>
